import React from 'react';
import { pxToRem } from '../util';
import CardHeader from './CardHeader';
import { toFixedNumber } from '@/utils/util';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const statitics = [
    {
      label: '累计建档',
      value: props.charts?.totalCharts?.archivesTotal || 0,
      suffix: '人',
    },
    {
      label: '上传报告人数',
      value: props.charts?.totalCharts?.hasReportArchivesTotal || 0,
      suffix: '人',
    },
    {
      label: '累计上传报告',
      value: props.charts?.totalCharts?.reportTotal || 0,
      suffix: '份',
    },
    {
      label: '报告上传率',
      value: toFixedNumber(
        (props.charts?.totalCharts?.reportUploadRate || 0) * 100,
        2
      ),
      suffix: '%',
    },
  ];
  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '22vh',
        maxHeight: '22vh',
        overflow: 'hidden',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      <CardHeader title="建档概览" subtitle="File creation overview" />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          marginTop: pxToRem(5),
          gap: pxToRem(5),
        }}
      >
        {statitics.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'rgba(10, 115, 255, 0.12)',
              width: '48%',
              padding: pxToRem(8),
              boxSizing: 'border-box',
              marginTop: '10px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: pxToRem(16), color: color }}>
              {item.label}
            </div>
            <div
              style={{
                fontSize: pxToRem(24),
                color: 'rgb(61, 171, 255)',
                fontWeight: 500,
              }}
            >
              {item.value.toLocaleString()}
              <span style={{ fontSize: pxToRem(14), marginLeft: '2px' }}>
                {item.suffix}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Box1;
